import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { fontFamilyAlt } from "@waytek/Utilities/variables";
import * as React from "react";
import { css } from "styled-components";

type Props = {
    futureAvailability: any;
    qtyOnHand: number;
    unitOfMeasure: string;
    qtyOnOrder: string;
};

export interface FutureAvailabilityTooltipStyles {
    tooltipTypography?: TypographyPresentationProps;
}

export const futureAvailabilityTooltipStyles: FutureAvailabilityTooltipStyles = {
    tooltipTypography: {
        size: "14px",
        fontFamily: fontFamilyAlt,
        css: css`
            text-align: left;
            &&& {
                font-size: 14px;
            }
        `,
    },
};

const styles = futureAvailabilityTooltipStyles;

export const FutureAvailabilityTooltip: React.FC<Props> = ({
    futureAvailability,
    qtyOnHand,
    unitOfMeasure,
    qtyOnOrder,
}) => {
    const changeDateMessage = siteMessage("ProductDetail_Availability_ChangeDate");

    return (
        <>
            {qtyOnHand > 0 && (
                <>
                    <Typography {...styles.tooltipTypography}>
                        {translate("ProductDetails_InStock_Message")
                            .replace("{0}", `${qtyOnHand?.toLocaleString("en-US") || 0}`)
                            .replace("{1}", unitOfMeasure)}
                    </Typography>
                    <br></br>
                </>
            )}
            <>
                <Typography {...styles.tooltipTypography}>
                    {translate("ProductDetails_OnOrder_Message").replace(
                        "{0}",
                        `${qtyOnOrder && qtyOnOrder.length > 0 ? qtyOnOrder : translate("TBD")}`,
                    )}
                </Typography>
                <br></br>
            </>
            <>
                <br></br>
                <Typography {...styles.tooltipTypography} weight={600}>
                    {translate("Estimated Ship Date(s):")}
                </Typography>
                {futureAvailability.length === 0 && (
                    <>
                        <br></br>
                        <Typography {...styles.tooltipTypography}>{translate("TBD")}</Typography>
                    </>
                )}
                {futureAvailability.length > 0 &&
                    futureAvailability.map((item: any, idx: number) => (
                        <>
                            <br></br>
                            <Typography
                                // eslint-disable-next-line react/no-array-index-key
                                key={idx}
                                {...styles.tooltipTypography}
                            >
                                {item["availableQtyDisplay"]}
                                {", "}
                                {item["availableDate"]}
                            </Typography>
                        </>
                    ))}
            </>
            {changeDateMessage && (
                <>
                    <br></br>
                    <br></br>
                    <StyledWrapper data-test-selector="availabilityDate">{changeDateMessage}</StyledWrapper>
                </>
            )}
        </>
    );
};
